export default {
  users: [],
  isMfaEnabled: false,
  isAddUsernameInEmailFormat: false,
  userRoles: []
};
